// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__xFwTM","redBtn":"Button_redBtn__Be5ci","blueBtn":"Button_blueBtn__vRmX+"};